export const deliveryTimeOptions: Record<string, string> = {
	immediately: 'Immediately available',
	short: 'Available in 1–2 months',
	quarter: 'Available in 3 months +',
} as const;

export const MIN_MATCHING_SCORE = 0.7;
